import { EventInteraction, EventInteractionContext } from '@eventbrite/ads';
import { FormattedEvent } from '@eventbrite/event-renderer';
import { OrganicEventSearchFiltersApiPayload } from '../../../api/searchOrganicEvents';
import { getBaseTrackingContext } from '../../../utils/tracking';

export const CATEGORY_BROWSE_PLACEMENT = 'home_category';
export const NIGHTLIFE_CATEGORY_BROWSE_PLACEMENT = 'home_category_nightlife';

export function aggregateContext({
    bucketName,
    bucketKey,
    bucketPosition,
    events = [],
    event,
    eventSearch = {},
    userId,
    locale,
    sessionId,
    guestId,
}: Omit<EventInteraction, 'action'> & {
    bucketName: string;
    bucketKey?: string;
    bucketPosition?: string;
    events: FormattedEvent[];
    eventSearch: OrganicEventSearchFiltersApiPayload;
    userId?: string;
    locale?: string;
    sessionId?: string;
    guestId?: string;
}): EventInteractionContext {
    const baseTrackingContext = getBaseTrackingContext({
        event,
        events,
        userId,
        locale,
        guestId,
        sessionId,
    });

    return {
        ...baseTrackingContext,
        place: {
            name: bucketName,
            page: 1,
            context: {
                date_filter: eventSearch.dates || null,
                query_terms: eventSearch.q || null,
                is_online: !!eventSearch.online_events_only,
                place_id: Array.isArray(eventSearch.places)
                    ? eventSearch.places[0]
                    : null,
                latitude: null,
                longitude: null,
                tags: event.tags || [],
            },
            subInterface: {
                name: bucketKey,
                position: bucketPosition,
            },
            ...baseTrackingContext.place,
        },
    };
}
